import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RequestFileService} from '../../../_services/api/request-file.service';
import {MatSnackBar} from '@angular/material/snack-bar';

export interface RequestItem{
  email: string;
  state: string;
  uuid: string;
  created_at: Date;
  files_added_at: Date;
  last_opened_at: Date;
  link: string;
  owner_name: string;
  is_selected: boolean;
  number_of_files: number;
  files_size: number;
  request_type: 'link' | 'email';
}

@Component({
  selector: 'app-request-item',
  templateUrl: './request-item.component.html',
  styleUrls: ['./request-item.component.scss']
})
export class RequestItemComponent implements OnInit {

  @Input() item: RequestItem;
  @Output() updateRequestItems: EventEmitter<any> = new EventEmitter();
  @Output() downloadRequestItems: EventEmitter<string> = new EventEmitter();

  resendingEmail: boolean;

  constructor(private requestFile: RequestFileService, private snackBar: MatSnackBar) {
    this.resendingEmail = false;
  }

  ngOnInit(): void {
  }

  selectByClick(){
    this.item.is_selected = !this.item.is_selected;
    this.updateRequestItems.emit();
  }

  download(){
    this.downloadRequestItems.emit(this.item.uuid);
  }

  getLink(){
    this.requestFile.copyLink(this.item.link);
  }

  resendEmail(){
    this.resendingEmail = true;
    this.requestFile.resend_email(this.item.uuid).subscribe(res => {
      this.snackBar.open('Email has been resend to ' + this.item.email, 'close', {
        duration: 2000,
      });
      this.resendingEmail = false;
    }, error => {
      this.snackBar.open('This email cannot be resent.', 'close', {
        duration: 2000,
      });
      this.resendingEmail = false;
    });
  }

}
